import React from "react";
import $ from "jquery";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import MyContext from "../../../../../api/context/my-context";
import leftPng from "../../../../../content/images/left.png";
import {PatchMethodAction} from "../../../../../api/omnimap/omnimapActions";
import {sleep} from "../../../../common/common";

class OrganizationEditModal extends React.Component {
    static contextType = MyContext;

    constructor(props) {
        super(props);
        this.state = {
            changedFields: []
        };

        this.baseState = this.state;
        this.handleInputChange = this.handleInputChange.bind(this);
        //this.handleEvent = this.handleEvent.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    useContext() {
        const context = React.useContext(MyContext.Consumer);
        if (context === undefined) {
            throw new Error("useCount must be used within a CountProvider");
        }
        return context;
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;


        this.setState({
            changedFields: [...this.state.changedFields, {
                op: "replace",
                path: name,
                value: value
            }]
        });
    }

    async handleSubmit(event) {
        const spin = $("#cover-spin");
        spin.show(0);
        const selected = $('#organization-edit-input-name').attr('data-selected')

        await PatchMethodAction(this.state.changedFields, selected,false)
        this.setState({
            changedFields: []
        })
        // Return back to table
        $("#tableSide").removeClass("d-none");
        $("#organisatie-detail").addClass("d-none");
        $("#editSide").addClass("d-none");
        //  and refresh
        sleep(1000).then(()=>{
            window.$catalog_users_organizations_refresh();
            spin.hide(0);
        })
    }


    async componentDidMount() {
    }

    render() {
        return (
                <div id="editSide" className="d-none">
                    <div className="detail-title">Organisatie in detail</div>
                    <div className="clearfix">
                        <div className="float-left mt-4">
                            <a id="detail-button" className="back-page-link" role="button">
                                <img src={leftPng} width={9} height={12}/> &nbsp;Terug naar
                                Organisatie
                            </a>
                        </div>
                        <div className="float-right mt-0">
                            <a id="edit_work_plans" className="button ok" onClick={this.handleSubmit} >
                                Opslaan
                            </a>
                        </div>
                        <div className="float-right mt-0 w-20">
                            <a id="return-detail" className="button back">
                                Annuleren
                            </a>
                        </div>
                    </div>

                    <div className="row clearfix">
                        <div className="col-lg-4 text-center">
                            <div className="box-detail-active">
                                <div className="box-title-1-active">Naam</div>
                                <div className="box-title-2-active">
                                    <input
                                        id="organization-edit-input-name"
                                        autoComplete="off"
                                        name="/content/algemeen/naamorganisatie"
                                        data-selected="" //here holds ıd of selected row
                                        onChange={this.handleInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 text-center">
                            <div className="box-detail">
                                <div className="box-title-1">Email</div>
                                <div className="box-title-2">
                                    <input
                                        id="organization-edit-input-email"
                                        autoComplete="off"
                                        name="/content/algemeen/email"
                                        onChange={this.handleInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 text-center">
                            <div className="box-detail">
                                <div className="box-title-1">Website</div>
                                <div className="box-title-2">
                                    <input
                                        id="organization-edit-input-website"
                                        autoComplete="off"
                                        name="/content/algemeen/website"
                                        onChange={this.handleInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row clearfix">
                        <div className="col-lg-4 text-center">
                            <div className="box-detail">
                                <div className="box-title-1">Straat</div>
                                <div className="box-title-2">
                                    <input
                                        id="organization-edit-input-street"
                                        autoComplete="off"
                                        name="/content/algemeen/straat"
                                        onChange={this.handleInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 text-center">
                            <div className="box-detail">
                                <div className="box-title-1">Nummer</div>
                                <div className="box-title-2">
                                    <input
                                        id="organization-edit-input-number"
                                        autoComplete="off"
                                        name="/content/algemeen/nummer"
                                        onChange={this.handleInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 text-center">
                            <div className="box-detail">
                                <div className="box-title-1">Postcode</div>
                                <div className="box-title-2">
                                    <input
                                        id="organization-edit-input-post-code"
                                        autoComplete="off"
                                        name="/content/algemeen/postcode"
                                        onChange={this.handleInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row clearfix">
                        <div className="col-lg-4 text-center">
                            <div className="box-detail">
                                <div className="box-title-1">Woonplaats</div>
                                <div className="box-title-2">
                                    <input
                                        id="organization-edit-input-residence"
                                        autoComplete="off"
                                        name="/content/algemeen/woonplaats"
                                        onChange={this.handleInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 text-center">
                            <div className="box-detail">
                                <div className="box-title-1">Opmerking</div>
                                <div className="box-title-2">
                                    <input
                                        id="organization-edit-input-remark"
                                        autoComplete="off"
                                        name="/content/algemeen/opmerking"
                                        onChange={this.handleInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row clearfix">
                        <div className="col-lg-4 text-center">
                            <div className="box-detail">
                                <div className="box-title-1">Actief</div>
                                <label className="switch">
                                    <input
                                        id="organization-edit-input-active"
                                        type="checkbox"
                                        name="/content/algemeen/actief"
                                        onChange={this.handleInputChange}
                                    />
                                    <span className="slider-checkbox round"/>
                                </label>
                            </div>
                        </div>
                        <div className="col-lg-4 text-center">
                            <div className="box-detail">
                                <div className="box-title-1">Is uitvoerder</div>
                                <label className="switch">
                                    <input
                                        id="organization-edit-input-is-general-executor"
                                        type="checkbox"
                                        name="/content/algemeen/isuitvoerder"
                                        onChange={this.handleInputChange}
                                    />
                                    <span className="slider-checkbox round"/>
                                </label>
                            </div>
                        </div>
                    </div>

                    <input hidden="true" id="e-identification"/>
                </div>
        );
    }
}

export default OrganizationEditModal;
